import React from "react";

const HelpResources = () => {
  return (
    <div className="helpful-resources">
      <h2>Helpful Links</h2>
      <ul>
        <li>
          HELPLINE NUMBERS (by State)
          <br />
          <a href="https://www.mohfw.gov.in/coronvavirushelplinenumber.pdf">
            https://www.mohfw.gov.in/coronvavirushelplinenumber.pdf
          </a>
        </li>
        <li>
          Ministry of Health and Family Welfare, Gov. of India<br></br>
          <a href="https://www.mohfw.gov.in/">https://www.mohfw.gov.in/</a>
        </li>
        <li>
          Twitter updates by Press Information Bureau <br />
          <a href="https://twitter.com/PIB_India">
            https://twitter.com/PIB_India
          </a>
        </li>
        <li>
          WHO : COVID-19 Guidelines
          <br></br>
          <a href="https://www.who.int/emergencies/diseases/novel-coronavirus-2019">
            https://www.who.int/emergencies/diseases/novel-coronavirus-2019
          </a>
        </li>
        <li>
          CDC <br />{" "}
          <a href="https://www.cdc.gov/coronavirus/2019-ncov/faq.html">
            https://www.cdc.gov/coronavirus/2019-ncov/faq.html
          </a>
        </li>
        <li>
          Myth Busters By WHO <br />{" "}
          <a href="https://www.who.int/emergencies/diseases/novel-coronavirus-2019/advice-for-public/myth-busters">
            https://www.who.int/emergencies/diseases/novel-coronavirus-2019/advice-for-public/myth-busters
          </a>
        </li>
      </ul>
    </div>
  );
};

export default HelpResources;
